import { slideStop, slideUp, slideDown } from "./slide-anim.js"

async function giftMessageInputEventListener(e, checkoutButtons) {
    try {
        checkoutButtons.forEach((checkoutButton) => {
            checkoutButton.disabled = true;
            checkoutButton.innerHTML = "Saving gift preferences...";
        })
        // Update gift status of order
        const res = await fetch(theme.routes.cart.update, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                attributes: {
                    order_gift_message: e.target.value
                },
            }),
        });
    } catch(error) {
        console.error("Error updating gift message of order: ", JSON.stringify(error));
        giftMessageInputWrapper.children[1].value = "";
    } finally {
        checkoutButtons.forEach((checkoutButton) => {
            checkoutButton.disabled = false;
            checkoutButton.innerHTML = "Checkout";
        })
    }
}

function toggleGiftMessageInput(giftMessageInputWrapper, checked) {
    try{
        console.log("Toggling");
        // Add or remove gift message text input listener based on cehcked status
        if(giftMessageInputWrapper) {
            if(checked) {
                giftMessageInputWrapper.setAttribute("aria-expanded", true);
                giftMessageInputWrapper.setAttribute("aria-hidden", false);
                slideStop(giftMessageInputWrapper);
                slideDown(giftMessageInputWrapper);
            } else {
                giftMessageInputWrapper.children[1].value = "";
                var event = new Event('change');
                giftMessageInputWrapper.children[1].dispatchEvent(event);
                giftMessageInputWrapper.setAttribute("aria-expanded", false);
                giftMessageInputWrapper.setAttribute("aria-hidden", true);
                slideStop(giftMessageInputWrapper);
                slideUp(giftMessageInputWrapper);
            }
        }
    } catch (err) {
        console.error("Error opening gift message input: ", err);
    }
}

async function updateGiftStatus(input, checked, giftMessageInputWrapper, checkoutButtons) {
    // Avoid spemmed clicks
    input.disabled = true;
    checkoutButtons.forEach((checkoutButton) => {
        checkoutButton.disabled = true;
        checkoutButton.innerHTML = "Saving gift preferences...";

    })
    toggleGiftMessageInput(giftMessageInputWrapper, checked);

    try {
        // Update gift status of order
        const res = await fetch(theme.routes.cart.update, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                attributes: {
                    order_is_gift: checked ? "Yes, this order is a gift." : "No, this order is not a gift."
                },
            }),
        });
        localStorage.setItem("order_is_gift", `${checked}`);
    } catch(error) {
        console.error("Error updating gift status of order: ", JSON.stringify(error));
        localStorage.setItem("order_is_gift", "");
        giftMessageInputWrapper.children[1].value = "";
        var event = new Event('change');
        giftMessageInputWrapper.children[1].dispatchEvent(event);
        input.checked = false;
    } finally {
        input.disabled = false;
        checkoutButtons.forEach((checkoutButton) => {
            checkoutButton.disabled = false;
            checkoutButton.innerHTML = "Checkout";
        })
    };
}

function isThisAGiftInit() {
    const giftCheckboxInputs = document.querySelectorAll('[data-gift-checkbox-input]');
    const giftMessageInputWrappers = document.querySelectorAll('[data-gift-message-input-wrapper]');
    const checkoutButtons = document.querySelectorAll('[name=checkout]');
    if(giftCheckboxInputs && giftCheckboxInputs.length > 0) {
        giftCheckboxInputs.forEach((giftCheckboxInput, index) => {
            if(giftCheckboxInput.dataset.listenerAttached === 'false'){
                const prechecked = localStorage.getItem("order_is_gift");
                if(prechecked === "true") {
                    giftCheckboxInput.checked = true;
                    toggleGiftMessageInput(giftMessageInputWrappers[index], true);
                } else {
                    giftCheckboxInput.checked = false;
                    toggleGiftMessageInput(giftMessageInputWrappers[index], false);
                }
                giftMessageInputWrappers[index].children[1].addEventListener("change", (e) => giftMessageInputEventListener(e, checkoutButtons));
        
                giftCheckboxInput.addEventListener("change", (e) => {
                    updateGiftStatus(giftCheckboxInput, e.target.checked, giftMessageInputWrappers[index], checkoutButtons);
                });
                giftCheckboxInput.dataset.listenerAttached = 'true';
            } 
        })
    }
}

document.addEventListener("cart:updated", function (evt) {
    console.log("Cart updated");
    console.log(evt.detail.cart);
    setTimeout(() => {
        isThisAGiftInit();
    }, 500);
}); 

document.addEventListener("DOMContentLoaded", () => {
    isThisAGiftInit();
});
  